// extracted by css-extract-rspack-plugin
export default {"block":"_c452e220","imageWrapper":"_1749cdd"};